import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { delay, dematerialize, materialize, mergeMap, tap } from 'rxjs/operators';

const datastore = {

  users: [
    {
      id: 1,
      username: 'admin',
      password: 'password',
      result: {
        // tslint:disable-next-line: max-line-length
        isConfirm: true, accessToken: 'token1234', username: 'admin', email: 'admin@someemail.com', role: 'admin', status: 2, route: [{displayName: 'Dashboard', iconName: 'dashboard', expectedRole: 'admin', route: 'dashboard', isShow: true}, {displayName: 'Service Catalog', iconName: 'service', expectedRole: 'admin', route: 'cataloges', isShow: true}, {displayName: 'Account Management', iconName: 'account', expectedRole: 'admin', route: 'accounts', isShow: true}, {displayName: 'Media Partner Management', iconName: 'content', expectedRole: 'admin', route: 'content_provider_management', isShow: true}, {displayName: 'Service Management', iconName: 'service', expectedRole: 'admin', route: 'service-management', isShow: true}, {displayName: 'Blocklist Management', iconName: 'block', expectedRole: 'admin', route: '', isShow: true, children: [{displayName: 'Blocklist Number', iconName: 'dot', expectedRole: 'admin', route: 'blocklist', isShow: true, class: 'icon-child'}]}, {displayName: 'Whitelist Number', iconName: 'white', expectedRole: 'admin', route: 'whitelist', isShow: true}, {displayName: 'Customer Service', iconName: 'customer', expectedRole: 'admin', route: 'customer_service', isShow: true}, {displayName: 'Content Management', iconName: 'upload', expectedRole: 'admin', route: '', isShow: true, children: [{displayName: 'Content Category', iconName: 'dot', expectedRole: 'admin', route: 'content_owner_management/category', isShow: true, class: 'icon-child'}, {displayName: 'Content Owner', iconName: 'dot', expectedRole: 'admin', route: 'content_owner_management/content', isShow: true, class: 'icon-child'}, {displayName: 'Upload Content', iconName: 'dot', expectedRole: 'admin', route: 'upload_content', isShow: true, class: 'icon-child'}]}, {displayName: 'Content ShortCode Mapping List', iconName: 'short_code', expectedRole: 'admin', route: 'content_short_code_mapping_list', isShow: true}, {displayName: 'Free Service Configuration', iconName: 'free_service', expectedRole: 'admin', route: 'free_service_config', isShow: true}, {displayName: 'Reports', iconName: 'report', expectedRole: 'admin', route: '', isShow: true, children: [{displayName: 'Subscription', iconName: 'dot', expectedRole: 'admin', route: 'reports/subscription', isShow: true, class: 'icon-child'}, {displayName: 'Transaction', iconName: 'dot', expectedRole: 'admin', route: 'reports/transaction', isShow: true, class: 'icon-child'}, {displayName: 'Revenue', iconName: 'dot', expectedRole: 'admin', route: 'reports/revenue', isShow: true, class: 'icon-child'}, {displayName: 'Content For Delivery', iconName: 'dot', expectedRole: 'admin', route: 'content_for_delivery', isShow: true, class: 'icon-child'}, {displayName: 'Content Delivered', iconName: 'dot', expectedRole: 'admin', route: 'content_delivered', isShow: true, class: 'icon-child'}]}, {displayName: 'Find Logs', iconName: 'free_service', expectedRole: 'admin', route: 'find_log', isShow: true}, {displayName: 'Profile', iconName: 'profile', expectedRole: 'admin', route: 'profile', isShow: false}]
      }
    }
  ],
  getUsers(): any[] {
    return this.users;
  }
};

const isMock = false;

@Injectable()
export class FakeBackendInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if ( !isMock ) { return next.handle(request); }
    const { url, method, headers, body } = request;
    const jsonBody = JSON.parse(body);

    const handleRoute = () => {
      console.log(`%c[FakeBackend] Url ${url} Method: ${method} Request ${body}`, 'background: #222; color: #16a596');
      switch (true) {
        // case url.endsWith('/auth/login') && method === 'POST':
        //   const found = datastore.getUsers().find(user => user.username === jsonBody.username && user.password === jsonBody.password);
        //   if ( found ) {
        //    return ok({ status: 200, message: 'Login successfully.', result: found.result });
        //   }
        //   return ok();
        case url.endsWith('/some-api') && method === 'GET':
          return ok({ status: 200, message: 'some-api-work'});
        default:
          // pass through any requests not handled above
          console.log(`%c[FakeBackend] Url ${url} Method: ${method} Passthrough`, 'background: #222; color: #16a596');
          return next.handle(request);
      }
    };

    // wrap in delayed observable to simulate server api call
    // call materialize and dematerialize to ensure delay even if an error is thrown
    // (https://github.com/Reactive-Extensions/RxJS/issues/648)
    return of(null)
      .pipe(mergeMap(handleRoute))
      .pipe(materialize())
      .pipe(delay(500))
      .pipe(tap(data => console.log(`%c[FakeBackend] Url ${url} Response: ${JSON.stringify(data)}`, 'background: #222; color: #16a596')))
      .pipe(dematerialize());

    // helper functions

    function encode(data) {
      // return jwt.encnpm(data, 'secret');
    }

    function ok(resBody?) {
      return of(new HttpResponse({ status: 200, body : resBody || {} }));
    }

    function error(message) {
      return throwError({ error: { message } });
    }

    function unauthorized() {
      return throwError({ status: 401, error: { message: 'Unauthorized' } });
    }

    function isLoggedIn() {
      return headers.get('Authorization') === 'Bearer fake-jwt-token';
    }

    function idFromUrl() {
      const urlParts = url.split('/');
      return parseInt(urlParts[urlParts.length - 1], 10);
    }
  }
}
